import { createFileRoute, Link } from "@tanstack/react-router"
import { NutritionQueuePage } from "../components/queues/nutrition-queue-page"
import { QueuesShell } from "../components/queues/queues-shell"
import { nutritionQueueSearchSchema } from "../services/use-nutrition-queue"

export const Route = createFileRoute("/queues/")({
  validateSearch: nutritionQueueSearchSchema,
  component: QueuesPage,
  errorComponent: () => (
    <QueuesShell>
      <p role="alert">Nutrition queue could not be displayed. Check the filters or reload.</p>

      <Link
        to="/queues"
        search={{ view: "all" }}
        className="inline-flex min-h-11 items-center text-info underline"
      >
        Clear filters
      </Link>
    </QueuesShell>
  ),
})
function QueuesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <NutritionQueuePage
      search={search}
      onChange={(next) => {
        void navigate({ search: next })
      }}
    />
  )
}
